import { appGoParam } from '../data/localParameters';
import * as storage from '../scripts/StorageParamName';
import { AppConfiguration } from "read-appsettings-json";
import { encrypt, decrypt } from '../utils/encryption';
import { noParamRedirect } from '../utils/redirect';
import { isLoginPage } from '../utils';

// Here we handle the browser's localStorage
let params = [];
let changedParams = [];

export function init() {
    return new Promise(async (resolve) => {
        getAppGoParams();

        if (params === null || params.length === 0) {
            const param = encryptParams(JSON.stringify(appGoParam));
            localStorage.setItem(storage.appgoParams, param);
            resolve();
        } else {
            resolve();
        }
    })
}

function save() {
    const param = encryptParams(JSON.stringify(changedParams));

    localStorage.setItem(storage.appgoParams, param);
}

function getAppGoParams(isEncrypt = true) {
    const param = localStorage.getItem(storage.appgoParams);

    let content = null;
    if (param !== null && param !== '[]') {
        content = decryptParams(param);
    }

    params = JSON.parse(content);
}

function encryptParams(param) {
    if (AppConfiguration.Setting().encryptStorage) {
        return encrypt(param);
    }

    return param;
}

function decryptParams(param) {
    if (AppConfiguration.Setting().encryptStorage) {
        try {
            const result = decrypt(param);

            return result;
        } catch (e) {
            localStorage.removeItem(storage.appgoParams);
        }
    }

    return param;
}

function saveParam(key, value) {
    getAppGoParams();

    if (params === null) {
        return;
    }

    changedParams = params;
    changedParams[key] = value;

    save();
}

function destroyParam(key) {
    getAppGoParams();

    if (params === null) {
        return;
    }

    changedParams = params;
    //changedParams[key] = [];
    changedParams[key] = null;

    save();
}

export function getParam(key) {
    getAppGoParams();

    return params !== null ? params[key] : null;
}

// ===== Start Config File =====

// Config ShowError
export function saveConfigShowError(value) {
    saveParam(storage.config.showError, value);
}

export function destroyConfigShowError() {
    destroyParam(storage.config.showError);
}

export function getConfigShowError() {
    return getParam(storage.config.showError);
}

// Config Token_ValidateMinutesInterval
export function saveConfigValidateMinutesInterval(value) {
    saveParam(storage.config.token.validateMinutesInterval, value);
}

export function destroyConfigValidateMinutesInterval() {
    destroyParam(storage.config.token.validateMinutesInterval);
}

export function getConfigValidateMinutesInterval() {
    return getParam(storage.config.token.validateMinutesInterval);
}

// Config Token_RenewMinutes
export function saveConfigRenewMinutes(value) {
    saveParam(storage.config.token.renewMinutes, value);
}

export function destroyConfigRenewMinutes() {
    destroyParam(storage.config.token.renewMinutes);
}

export function getConfigRenewMinutes() {
    return getParam(storage.config.token.renewMinutes);
}

// Config LogInfoDevice
export function saveConfigLogInfoDevice(value) {
    saveParam(storage.config.logInfoDevice, value);
}

export function destroyConfigLogInfoDevice() {
    destroyParam(storage.config.logInfoDevice);
}

export function getConfigLogInfoDevice() {
    return getParam(storage.config.logInfoDevice);
}

// Config EncryptStorage
export function saveConfigEncryptStorage(value) {
    saveParam(storage.config.encryptStorage, value);
}

export function destroyConfigEncryptStorage() {
    destroyParam(storage.config.encryptStorage);
}

export function getConfigEncryptStorage() {
    return getParam(storage.config.encryptStorage);
}

// Config EncryptKey
export function saveConfigEncryptKey(value) {
    saveParam(storage.config.encryptKey, value);
}

export function destroyConfigEncryptKey() {
    destroyParam(storage.config.encryptKey);
}

export function getConfigEncryptKey() {
    return getParam(storage.config.encryptKey);
}

// Config EncryptKeyPassword
export function saveConfigEncryptKeyPassword(value) {
    saveParam(storage.config.encryptKeyPassword, value);
}

export function destroyConfigEncryptKeyPassword() {
    destroyParam(storage.config.encryptKeyPassword);
}

export function getConfigEncryptKeyPassword() {
    return getParam(storage.config.encryptKeyPassword);
}

// Config EntraId_RootBase
export function saveConfigRootBase(value) {
    saveParam(storage.config.entraId.rootBase, value);
}

export function destroyConfigRootBase() {
    destroyParam(storage.config.entraId.rootBase);
}

export function getConfigRootBase() {
    return getParam(storage.config.entraId.rootBase);
}

// Config EntraId_ClientId
export function saveConfigClientId(value) {
    saveParam(storage.config.entraId.clientId, value);
}

export function destroyConfigClientId() {
    destroyParam(storage.config.entraId.clientId);
}

export function getConfigClientId() {
    return getParam(storage.config.entraId.clientId);
}


// Config EntraId_TenantId
export function saveConfigTenantId(value) {
    saveParam(storage.config.entraId.tenantId, value);
}

export function destroyConfigTenantId() {
    destroyParam(storage.config.entraId.tenantId);
}

export function getConfigTenantId() {
    return getParam(storage.config.entraId.tenantId);
}

// Config OnlineHelp_FrenchLink
export function saveConfigOnlineHelpFrenchLink(value) {
    saveParam(storage.config.onlineHelp.frenchLink, value);
}

export function destroyConfigOnlineHelpFrenchLink() {
    destroyParam(storage.config.onlineHelp.frenchLink);
}

export function getConfigOnlineHelpFrenchLink() {
    return getParam(storage.config.onlineHelp.frenchLink);
}

// Config OnlineHelp_EnglishLink
export function saveConfigOnlineHelpEnglishLink(value) {
    saveParam(storage.config.onlineHelp.englishLink, value);
}

export function destroyConfigOnlineHelpEnglishLink() {
    destroyParam(storage.config.onlineHelp.englishLink);
}

export function getConfigOnlineHelpEnglishLink() {
    return getParam(storage.config.onlineHelp.englishLink);
}

// Config CompanyTitle
export function saveConfigCompanyTitle(value) {
    saveParam(storage.config.companyTitle, value);
}

export function destroyConfigCompanyTitle() {
    destroyParam(storage.config.companyTitle);
}

export function getConfigCompanyTitle() {
    return getParam(storage.config.companyTitle);
}

// Config EntraId_Authority
export function saveConfigAuthority(value) {
    saveParam(storage.config.entraId.authority, value);
}

export function destroyConfigAuthority() {
    destroyParam(storage.config.entraId.authority);
}

export function getConfigAuthority() {
    return getParam(storage.config.entraId.authority);
}

// Config EntraId_RedirectUri
export function saveConfigRedirectUri(value) {
    saveParam(storage.config.entraId.redirectUri, value);
}

export function destroyConfigRedirectUri() {
    destroyParam(storage.config.entraId.redirectUri);
}

export function getConfigRedirectUri() {
    return getParam(storage.config.entraId.redirectUri);
}

// Config EntraId_RedirectLogout
export function saveConfigRedirectLogout(value) {
    saveParam(storage.config.entraId.redirectLogout, value);
}

export function destroyConfigRedirectLogout() {
    destroyParam(storage.config.entraId.redirectLogout);
}

export function getConfigRedirectLogout() {
    return getParam(storage.config.entraId.redirectLogout);
}

// Config intervalWaitSSO
export function saveConfigIntervalWaitSSO(value) {
    saveParam(storage.config.intervalWaitSSO, value);
}

export function destroyConfigIntervalWaitSSO() {
    destroyParam(storage.config.intervalWaitSSO);
}

export function getConfigIntervalWaitSSO() {
    return getParam(storage.config.intervalWaitSSO);
}

// ===== End Config File =====


// userCode
export function saveUserCode(value) {
    saveParam(storage.userCode, value);
}

export function destroyUserCode() {
    destroyParam(storage.userCode);
}

export function getUserCode() {
    return getParam(storage.userCode);
}

// userName
export function saveUserName(value) {
    saveParam(storage.userName, value);
}

export function destroyUserName() {
    destroyParam(storage.userName);
}

export function getUserName() {
    return getParam(storage.userName);
}

// employeeId
export function saveEmployeeId(value) {
    saveParam(storage.employeeId, value);
}

export function destroyEmployeeId() {
    destroyParam(storage.employeeId);
}

export function getEmployeeId() {
    return getParam(storage.employeeId);
}


// menu
export function saveMenu(value) {
    saveParam(storage.menu, value);
}

export function destroyMenu() {
    destroyParam(storage.menu);
}

export function getMenu() {
    return getParam(storage.menu);
}


// abcUsage
export function saveAbcUsage(value) {
    saveParam(storage.abcUsage, value);
}

export function destroyAbcUsage() {
    destroyParam(storage.abcUsage);
}

export function getAbcUsage() {
    return getParam(storage.abcUsage);
}


// linkProjectPActivity
export function saveLinkProjectPActivity(value) {
    saveParam(storage.linkProjectPActivity, value);
}

export function destroyLinkProjectPActivity() {
    destroyParam(storage.linkProjectPActivity);
}

export function getLinkProjectPActivity() {
    return getParam(storage.linkProjectPActivity);
}


// language
export function saveLanguage(value) {
    saveParam(storage.language, value);
}

export function destroyLanguage() {
    destroyParam(storage.language);
}

export function getLanguage() {
    return getParam(storage.language);
}


// googleApiKey
export function saveGoogleApiKey(value) {
    saveParam(storage.googleApiKey, value);
}

export function destroyGoogleApiKey() {
    destroyParam(storage.googleApiKey);
}

export function getGoogleApiKey() {
    return getParam(storage.googleApiKey);
}


// token
export function saveToken(value) {
    saveParam(storage.token, value);
}

export function destroyToken() {
    destroyParam(storage.token);
}

export function getToken() {
    return getParam(storage.token);
}


// sessionGuid
export function saveSessionGuid(value) {
    saveParam(storage.sessionGuid, value);
}

export function destroySessionGuid() {
    destroyParam(storage.sessionGuid);
}

export function getSessionGuid() {
    return getParam(storage.sessionGuid);
}


// expenseAccountActivities
export function saveExpenseAccountActivities(value) {
    saveParam(storage.expenseAccountActivities, value);
}

export function destroyExpenseAccountActivities() {
    destroyParam(storage.expenseAccountActivities);
}

export function getExpenseAccountActivities() {
    return getParam(storage.expenseAccountActivities);
}

// Timesheet
export function saveExpandedTimesheet(value) {
    saveParam(storage.expandedTimesheet, value);
}

export function destroyExpandedTimesheet() {
    destroyParam(storage.expandedTimesheet);
}

export function getExpandedTimesheet() {
    return getParam(storage.expandedTimesheet);
}

// StartDayTimesheet
export function saveStartDayTimesheet(value) {
    saveParam(storage.startDayTimesheet, value);
}

export function destroyStartDayTimesheet() {
    destroyParam(storage.startDayTimesheet);
}

export function getStartDayTimesheet() {
    return getParam(storage.startDayTimesheet);
}

// useTimeTimesheet
export function saveUseTimeTimesheet(value) {
    saveParam(storage.useTimeTimesheet, value);
}

export function destroyUseTimeTimesheet() {
    destroyParam(storage.useTimeTimesheet);
}

export function getUseTimeTimesheet() {
    return getParam(storage.useTimeTimesheet);
}

// useTimeTimesheetRequired
export function saveUseTimeTimesheetRequired(value) {
    saveParam(storage.useTimeTimesheetRequired, value);
}

export function destroyUseTimeTimesheetRequired() {
    destroyParam(storage.useTimeTimesheetRequired);
}

export function getUseTimeTimesheetRequired() {
    return getParam(storage.useTimeTimesheetRequired);
}

// acceptedTermsUse
export function saveAcceptedTermsUse(value) {
    saveParam(storage.acceptedTermsUse, value);
}

export function destroyAcceptedTermsUse() {
    destroyParam(storage.acceptedTermsUse);
}

export function getAcceptedTermsUse() {
    return getParam(storage.acceptedTermsUse);
}

// termsUse
export function saveTermsUse(value) {
    saveParam(storage.termsUse, value);
}

export function destroyTermsUse() {
    destroyParam(storage.termsUse);
}

export function getTermsUse() {
    return getParam(storage.termsUse);
}

// legalInfo
export function saveLegalInfo(value) {
    saveParam(storage.legalInfo, value);
}

export function destroyLegalInfo() {
    destroyParam(storage.legalInfo);
}

export function getLegalInfo() {
    return getParam(storage.legalInfo);
}

// showDateStatementTerms
export function saveShowDateStatementTerms(value) {
    saveParam(storage.showDateStatementTerms, value);
}

export function destroyShowDateStatementTerms() {
    destroyParam(storage.showDateStatementTerms);
}

export function getShowDateStatementTerms() {
    return getParam(storage.showDateStatementTerms);
}

// showDateStatementLegalInfo
export function saveShowDateStatementLegalInfo(value) {
    saveParam(storage.showDateStatementLegalInfo, value);
}

export function destroyShowDateStatementLegalInfo() {
    destroyParam(storage.showDateStatementLegalInfo);
}

export function getShowDateStatementLegalInfo() {
    return getParam(storage.showDateStatementLegalInfo);
}

// scheduleReturnDate
export function saveScheduleReturnDate(value) {
    saveParam(storage.scheduleReturnDate, value);
}

export function destroyScheduleReturnDate() {
    destroyParam(storage.scheduleReturnDate);
}

export function getScheduleReturnDate() {
    return getParam(storage.scheduleReturnDate);
}

// filterRequest
export function saveFilterRequest(value) {
    saveParam(storage.filterRequest, value);
}

export function destroyFilterRequest() {
    destroyParam(storage.filterRequest);
}

export function getFilterRequest() {
    return getParam(storage.filterRequest);
}

// isPasswordComplex
export function saveIsPasswordComplex(value) {
    saveParam(storage.isPasswordComplex, value);
}

export function destroyIsPasswordComplex() {
    destroyParam(storage.isPasswordComplex);
}

export function getIsPasswordComplex() {
    return getParam(storage.isPasswordComplex);
}

// minLengthPassword
export function saveMinLengthPassword(value) {
    saveParam(storage.minLengthPassword, value);
}

export function destroyMinLengthPassword() {
    destroyParam(storage.minLengthPassword);
}

export function getMinLengthPassword() {
    return getParam(storage.minLengthPassword);
}

// clientHashKey
export function saveClientHashKey(value) {
    saveParam(storage.clientHashKey, value);
}

export function destroyClientHashKey() {
    destroyParam(storage.clientHashKey);
}

export function getClientHashKey() {
    return getParam(storage.clientHashKey);
}

// UseGeolocation
export function saveUseGeolocation(value) {
    saveParam(storage.useGeolocation, value);
}

export function destroyUseGeolocation() {
    destroyParam(storage.useGeolocation);
}

export function getUseGeolocation() {
    return getParam(storage.useGeolocation);
}

// UseGeolocationZone
export function saveUseGeolocationZone(value) {
    saveParam(storage.useGeolocationZone, value);
}

export function destroyUseGeolocationZone() {
    destroyParam(storage.useGeolocationZone);
}

export function getUseGeolocationZone() {
    return getParam(storage.useGeolocationZone);
}

// CreditCardSupport
export function saveCreditCardSupport(value) {
    saveParam(storage.creditCardSupport, value);
}

export function destroyCreditCardSupport() {
    destroyParam(storage.creditCardSupport);
}

export function getCreditCardSupport() {
    return getParam(storage.creditCardSupport);
}

// Companies
export function saveCompanies(value) {
    saveParam(storage.companies, value);
}

export function destroyCompanies() {
    destroyParam(storage.companies);
}

export function getCompanies() {
    return getParam(storage.companies);
}

// PunchTime
export function savePunchTime(value) {
    saveParam(storage.punchTime, value);
}

export function destroyPunchTime() {
    destroyParam(storage.punchTime);
}

export function getPunchTime() {
    return getParam(storage.punchTime);
}

// ColorCalendar
export function saveColorCalendar(value) {
    saveParam(storage.colorCalendar, value);
}

export function destroyColorCalendar() {
    destroyParam(storage.colorCalendar);
}

export function getColorCalendar() {
    return getParam(storage.colorCalendar);
}

// UseWorkInstructions
export function saveUseWorkInstructions(value) {
    saveParam(storage.useWorkInstructions, value);
}

export function destroyUseWorkInstructions() {
    destroyParam(storage.useWorkInstructions);
}

export function getUseWorkInstructions() {
    return getParam(storage.useWorkInstructions);
}

// DisplayMedicalData
export function saveDisplayMedicalData(value) {
    saveParam(storage.displayMedicalData, value);
}

export function destroyDisplayMedicalData() {
    destroyParam(storage.displayMedicalData);
}

export function getDisplayMedicalData() {
    return getParam(storage.displayMedicalData);
}

// DisplayDistributionSlip
export function saveDisplayDistributionSlip(value) {
    saveParam(storage.displayDistributionSlip, value);
}

export function destroyDisplayDistributionSlip() {
    destroyParam(storage.displayDistributionSlip);
}

export function getDisplayDistributionSlip() {
    return getParam(storage.displayDistributionSlip);
}

// DisplayPreferenceCommunication
export function saveDisplayPreferenceCommunication(value) {
    saveParam(storage.displayPreferenceCommunication, value);
}

export function destroyDisplayPreferenceCommunication() {
    destroyParam(storage.displayPreferenceCommunication);
}

export function getDisplayPreferenceCommunication() {
    return getParam(storage.displayPreferenceCommunication);
}

export function saveDisplayFlagFullTime(value) {
    saveParam(storage.isDisplayFlagFullTime, value);
}
export function getDisplayFlagFullTime() {
    return getParam(storage.isDisplayFlagFullTime);
}

export function destroyDisplayFlagFullTime() {
    destroyParam(storage.isDisplayFlagFullTime);
}

// IsCCQ
export function saveIsCCQ(value) {
    saveParam(storage.isCCQ, value);
}

export function destroyIsCCQ() {
    destroyParam(storage.isCCQ);
}

export function getIsCCQ() {
    return getParam(storage.isCCQ);
}

export function savePartialRequestHoursUsed(value) {
    saveParam(storage.partialRequestHoursUsed, value);
}

export function destroyPartialRequestHoursUsed() {
    destroyParam(storage.partialRequestHoursUsed);
}

export function getPartialRequestHoursUsed() {
    return getParam(storage.partialRequestHoursUsed);
}

// ConnectionString
export function saveConnectionString(value) {
    saveParam(storage.connectionString, value);
}

export function destroyConnectionString() {
    destroyParam(storage.connectionString);
}

export function getConnectionString() {
    return getParam(storage.connectionString);
}

// TaxationProvince
export function saveTaxationProvince(value) {
    saveParam(storage.taxationProvince, value);
}

export function destroyTaxationProvince() {
    destroyParam(storage.taxationProvince);
}

export function getTaxationProvince() {
    return getParam(storage.taxationProvince);
}

// FilterExpenseAccount
export function saveFilterExpenseAccount(value) {
    saveParam(storage.filterExpenseAccount, value);
}

export function destroyFilterExpenseAccount() {
    destroyParam(storage.filterExpenseAccount);
}

export function getFilterExpenseAccount() {
    return getParam(storage.filterExpenseAccount);
}

// IsMandatoryPhoneCellPerso
export function saveIsMandatoryPhoneCellPerso(value) {
    saveParam(storage.isMandatoryPhoneCellPerso, value);
}

export function destroyIsMandatoryPhoneCellPerso() {
    destroyParam(storage.isMandatoryPhoneCellPerso);
}

export function getIsMandatoryPhoneCellPerso() {
    return getParam(storage.isMandatoryPhoneCellPerso);
}

// IsMandatoryEmailPerso
export function saveIsMandatoryEmailPerso(value) {
    saveParam(storage.isMandatoryEmailPerso, value);
}

export function destroyIsMandatoryEmailPerso() {
    destroyParam(storage.isMandatoryEmailPerso);
}

export function getIsMandatoryEmailPerso() {
    return getParam(storage.isMandatoryEmailPerso);
}

// IsMandatoryEmailPerso
export function saveIsDisplayPayAdvanceVacation(value) {
    saveParam(storage.isDisplayPayAdvanceVacation, value);
}

export function destroyIsDisplayPayAdvanceVacation() {
    destroyParam(storage.isDisplayPayAdvanceVacation);
}

export function getIsDisplayPayAdvanceVacation() {
    return getParam(storage.isDisplayPayAdvanceVacation);
}

// IsMandatorySMSPerso
export function saveIsMandatorySMSPerso(value) {
    saveParam(storage.isMandatorySMSPerso, value);
}

export function destroyIsMandatorySMSPerso() {
    destroyParam(storage.isMandatorySMSPerso);
}

export function getIsMandatorySMSPerso() {
    return getParam(storage.isMandatorySMSPerso);
}

// CommunicationPreference
export function saveCommunicationPreference(value) {
    saveParam(storage.communicationPreference, value);
}

export function destroyCommunicationPreference() {
    destroyParam(storage.communicationPreference);
}

export function getCommunicationPreference() {
    return getParam(storage.communicationPreference);
}

// IsUsePartialRequest
export function saveIsUsePartialRequest(value) {
    saveParam(storage.isUsePartialRequest, value);
}

export function destroyIsUsePartialRequest() {
    destroyParam(storage.isUsePartialRequest);
}

export function getIsUsePartialRequest() {
    return getParam(storage.isUsePartialRequest);
}

// IsSSO
export function saveIsSSO(value) {
    saveParam(storage.isSSO, value);
}

export function destroyIsSSO() {
    destroyParam(storage.isSSO);
}

export function getIsSSO() {
    return getParam(storage.isSSO);
}

// IsAuthSSO
export function saveIsAuthSSO(value) {
    saveParam(storage.isSSO, value);
}

export function destroyIsAuthSSO() {
    destroyParam(storage.isSSO);
}

export function getIsAuthSSO() {
    return getParam(storage.isSSO);
}

// IsDisplayPayablesHours
export function saveIsDisplayPayablesHours(value) {
    saveParam(storage.isDisplayPayablesHours, value);
}

export function destroyIsDisplayPayablesHours() {
    destroyParam(storage.isDisplayPayablesHours);
}

export function getIsDisplayPayablesHours() {
    return getParam(storage.isDisplayPayablesHours);
}

// IsUseMaterialResourceTimesheet
export function saveIsUseMaterialResourceTimesheet(value) {
    saveParam(storage.isUseMaterialResourceTimesheet, value);
}

export function destroyIsUseMaterialResourceTimesheet() {
    destroyParam(storage.isUseMaterialResourceTimesheet);
}

export function getIsUseMaterialResourceTimesheet() {
    return getParam(storage.isUseMaterialResourceTimesheet);
}

// ShowSubscribe
export function saveShowSubscribe(value) {
    saveParam(storage.showSubscribe, value);
}

export function destroyShowSubscribe() {
    destroyParam(storage.showSubscribe);
}

export function getShowSubscribe() {
    return getParam(storage.showSubscribe);
}

// NotificationPublicKey
export function saveNotificationPublicKey(value) {
    saveParam(storage.notificationPublicKey, value);
}

export function destroyNotificationPublicKey() {
    destroyParam(storage.notificationPublicKey);
}

export function getNotificationPublicKey() {
    return getParam(storage.notificationPublicKey);
}

// NotificationPrivateKey
export function saveNotificationPrivateKey(value) {
    saveParam(storage.notificationPrivateKey, value);
}

export function destroyNotificationPrivateKey() {
    destroyParam(storage.notificationPrivateKey);
}

export function getNotificationPrivateKey() {
    return getParam(storage.notificationPrivateKey);
}

// IsNotificationActivate
export function saveIsNotificationActivate(value) {
    saveParam(storage.isNotificationActivate, value);
}

export function destroyIsNotificationActivate() {
    destroyParam(storage.isNotificationActivate);
}

export function getIsNotificationActivate() {
    return getParam(storage.isNotificationActivate);
}

// IsProfileConsultationMode
export function saveIsProfileConsultationMode(value) {
    saveParam(storage.isProfileConsultationMode, value);
}

export function destroyIsProfileConsultationMode() {
    destroyParam(storage.isProfileConsultationMode);
}

export function getIsProfileConsultationMode() {
    return getParam(storage.isProfileConsultationMode);
}

// ListPrefixConnection
export function saveListPrefixConnection(value) {
    saveParam(storage.listPrefixConnection, value);
}

export function destroyListPrefixConnection() {
    destroyParam(storage.listPrefixConnection);
}

export function getListPrefixConnection() {
    return getParam(storage.listPrefixConnection);
}

// IsDisplayBankOthers
export function saveIsDisplayBankOthers(value) {
    saveParam(storage.isDisplayBankOthers, value);
}

export function destroyIsDisplayBankOthers() {
    destroyParam(storage.isDisplayBankOthers);
}

export function getIsDisplayBankOthers() {
    return getParam(storage.isDisplayBankOthers);
}

// IsDisplayBankVacation
export function saveIsDisplayBankVacation(value) {
    saveParam(storage.isDisplayBankVacation, value);
}

export function destroyIsDisplayBankVacation() {
    destroyParam(storage.isDisplayBankVacation);
}

export function getIsDisplayBankVacation() {
    return getParam(storage.isDisplayBankVacation);
}

// UseServiceProvider
export function saveUseServiceProvider(value) {
    saveParam(storage.useServiceProvider, value);
}

export function destroyUseServiceProvider() {
    destroyParam(storage.useServiceProvider);
}

export function getUseServiceProvider() {
    return getParam(storage.useServiceProvider);
}

// UseGeolocationMandatory
export function saveUseGeolocationMandatory(value) {
    saveParam(storage.useGeolocationMandatory, value);
}

export function destroyUseGeolocationMandatory() {
    destroyParam(storage.useGeolocationMandatory);
}

export function getUseGeolocationMandatory() {
    return getParam(storage.useGeolocationMandatory);
}